"use strict";
/** @module context */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslation = exports.I18nextProvider = exports.LocalProvider = exports.ApiProvider = exports.LocalContext = exports.ApiContext = void 0;
exports.useApi = useApi;
exports.useLocal = useLocal;
exports.withContext = withContext;
var React = require("react");
var react_i18next_1 = require("react-i18next");
var functions_1 = require("./utils/functions");
/**
 * Get display name of component.
 * @param Component
 */
function getDisplayName(Component) {
    // React.ComponentType<any> | string
    return (Component.displayName ||
        Component.name ||
        (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown'));
}
/******************
 CREATE CONTEXTS
 *******************/
exports.ApiContext = React.createContext({});
exports.LocalContext = React.createContext({});
/******************
 EXPORT PROVIDERS
 *******************/
exports.ApiProvider = exports.ApiContext.Provider;
exports.LocalProvider = exports.LocalContext.Provider;
var react_i18next_2 = require("react-i18next");
Object.defineProperty(exports, "I18nextProvider", { enumerable: true, get: function () { return react_i18next_2.I18nextProvider; } });
Object.defineProperty(exports, "useTranslation", { enumerable: true, get: function () { return react_i18next_2.useTranslation; } });
/**
 * Use API hook.
 * @return Object with api context values.
 */
function useApi() {
    var api = React.useContext(exports.ApiContext);
    var ret = [api];
    ret.api = api;
    return ret;
}
/**
 * Use local storage hook.
 * @return Object with local storage context values.
 */
function useLocal() {
    var local = React.useContext(exports.LocalContext);
    var ret = [local];
    ret.local = local;
    return ret;
}
/*
<P extends WithTranslation>(component: React.ComponentType<P>) => React.ComponentType<Omit<P, keyof WithTranslation>>;
*/
/**
 * Renders component with context.
 * @param Component
 * @param context
 * @return Connected component
 */
function withContext(
// Component: React.ComponentType<P extends Partial<WithTranslation>, Partial<WithApi>, Partial<WithLocal>>,
Component) {
    var context = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        context[_i - 1] = arguments[_i];
    }
    // Return component if no contexts.
    if (context.length === 0) {
        return Component;
    }
    // Partial<T>
    // Make WithContext component.
    var WithContext = function (_a) {
        var forwardedRef = _a.forwardedRef, rest = __rest(_a, ["forwardedRef"]);
        var passDownProps = __assign({}, rest);
        context.forEach(function (c) {
            switch (c) {
                case 'i18n':
                    var _a = (0, react_i18next_1.useTranslation)(), t = _a[0], i18n = _a[1], tReady = _a[2];
                    passDownProps.t = t;
                    passDownProps.i18n = i18n;
                    passDownProps.tReady = tReady;
                    break;
                case 'api':
                    var api = useApi()[0];
                    passDownProps.api = api;
                    break;
                case 'local':
                    var local = useLocal()[0];
                    passDownProps.local = local;
                    break;
                default:
                    throw new Error("'".concat(c, "' is not valid context type."));
            }
        });
        // if (options.withRef && forwardedRef) {
        //   passDownProps.ref = forwardedRef;
        // }
        return React.createElement(Component, passDownProps);
    };
    // Set WithContext display name.
    WithContext.displayName = getDisplayName(Component);
    context.forEach(function (c) {
        if (c === 'i18n') {
            WithContext.displayName = "WithTranslation(".concat(WithContext.displayName, ")");
        }
        else {
            WithContext.displayName = "With".concat((0, functions_1.toTitleCase)(c), "(").concat(WithContext.displayName, ")");
        }
    });
    // Set wrapped component
    WithContext.WrappedComponent = Component;
    // const forwardRef = (props, ref) => React.createElement(WithContext, Object.assign({}, props, { forwardedRef: ref }));
    // return options.withRef ? React.forwardRef(forwardRef) : WithContext;
    return WithContext;
}
//# sourceMappingURL=context.js.map